// App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { CustomScroll } from 'react-custom-scroll';
import Apps from './pages/Apps';
import AppDetail from './pages/AppDetail';
import Servers from './pages/Servers';
import ServerDetail from './pages/ServerDetail';
import Login from './pages/Login';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeProvider';

// Single authenticated shell — the nav bar used to be repeated inside every
// route element.
const AppLayout = () => (
  <>
    <Navigation />
    <main className="py-6">
      <Outlet />
    </main>
  </>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="h-screen bg-page">
            <CustomScroll heightRelativeToParent="100%">
              <Routes>
                <Route path="/login" element={<Login />} />

                <Route
                  element={
                    <ProtectedRoute>
                      <AppLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route path="/" element={<Servers />} />
                  <Route path="/servers/:id" element={<ServerDetail />} />
                  <Route path="/apps" element={<Apps />} />
                  <Route path="/apps/:id" element={<AppDetail />} />
                  <Route path="*" element={<Servers />} />
                </Route>
              </Routes>
            </CustomScroll>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
